import { parseHelpMarkdown, type HelpDocument } from '@inventohub/shared';

const files = import.meta.glob('./articles/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

export const HELP_DOCUMENTS: HelpDocument[] = Object.entries(files).map(([path, source]) => {
  try {
    return parseHelpMarkdown(source);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'invalid help markdown';
    throw new Error(`${path}: ${message}`, { cause: error });
  }
});

export function helpDocumentBySlug(slug: string): HelpDocument | undefined {
  return HELP_DOCUMENTS.find((doc) => doc.slug === slug);
}
